import React from "react";
import { IImageData } from "../../Utility";

export interface IGalleryContext {
  /**
   * Set of images data
   */
  images: IImageData[];

  /**
   * Set currently active item
   */
  activeItem?: IImageData;

  /**
   * A callback function on when image is selected
   */
  onSelect?: (image: IImageData) => void;
}

export const GalleryContext = React.createContext<IGalleryContext>({
  images: [],
});
